/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Submitfailed1Inputs */

const en_questionnaire_submitfailed1 = /** @type {(inputs: Questionnaire_Submitfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to submit questionnaire. Please try again.`)
};

const fr_questionnaire_submitfailed1 = /** @type {(inputs: Questionnaire_Submitfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'envoi du questionnaire. Veuillez réessayer.`)
};

/**
* | output |
* | --- |
* | "Failed to submit questionnaire. Please try again." |
*
* @param {Questionnaire_Submitfailed1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_submitfailed1 = /** @type {((inputs?: Questionnaire_Submitfailed1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Submitfailed1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_submitfailed1(inputs)
	return fr_questionnaire_submitfailed1(inputs)
});
export { questionnaire_submitfailed1 as "questionnaire_submitFailed" }